import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { createNew } from '~publish/legacy/routes'
import { actions as composerPopoverActions } from '~publish/legacy/composer-popover'
import { SEGMENT_NAMES } from '~publish/legacy/constants'
import type { RouterActions } from 'redux-first-history'
import { useChannels } from '~publish/components/PublishSidebar/useChannels'
import { useAccount } from '~publish/contexts/AccountContext'

type Action = () => void

export const useWelcomeCheckListActions = (): {
  callWelcomeChecklistAction: (action: number) => void
} => {
  const dispatch = useDispatch()
  const { channels } = useChannels()
  const { account } = useAccount()
  const connectedChannelIds = channels.map((channel) => channel.id)

  // TO DO: update use of location change in Redux
  // https://linear.app/buffer/issue/CHAN-5410/redux-navigation-audit-document-use-of-push-in-middleware-and-location
  const onCreateIdeaClick = (): RouterActions => dispatch(createNew.goTo())

  const handleConnectChannel = (): void => {
    const { actions } = window.appshell
    actions.openChannelStorefront({
      cta: 'publish-welcomeChecklist-listItem-connectYourFirstChannel-1',
    })
  }

  const onPublishFirstPostClick = ({
    selectedProfileId,
    selectedProfileIds,
  }: {
    selectedProfileId: string | undefined
    selectedProfileIds?: string[]
  }): void => {
    dispatch(
      composerPopoverActions.handleCreatePostClick({
        selectedProfileId,
        selectedProfileIds,
        cta: SEGMENT_NAMES.CALENDAR_CREATE_A_POST,
      }),
    )
  }
  // NOTE: Currently hardcoded for showing checklist 1 only. We'll make this more dynamic as we add checklists
  const noOp = useCallback(() => undefined, [])
  const WELCOME_CHECKLIST_LINKS: Record<number, Action> = {
    1: () => noOp(),
    2: () => handleConnectChannel(),
    3: () => onCreateIdeaClick(),
    4: () =>
      onPublishFirstPostClick({
        selectedProfileId: undefined,
        selectedProfileIds: [],
      }),
  }

  // Create a method to call actions
  const callWelcomeChecklistAction = (action: number): void => {
    WELCOME_CHECKLIST_LINKS[action]()
  }

  return { callWelcomeChecklistAction }
}
